<template>
  <div class="hello">
    <div class="text-titel">快速记录</div>
    <div style="margin-bottom: 20px">
      <el-date-picker
        v-model="recordsdata.valuetime"
        type="datetime"
        placeholder="选择日期时间"
      >
      </el-date-picker>
    </div>
    <div style="display: flex">
      <div class="box-one" style="margin-bottom: 20px">
        <div>地址:</div>
        <el-select
          v-model="recordsdata.addressid"
          placeholder="请选择"
          style="width: 70%"
        >
          <el-option
            v-for="item in addressdata"
            :key="item"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>

    <div>
      <div class="box-one" style="margin-bottom: 20px">
        <div>赛制:</div>
        <el-radio v-model="radio" label="1">单打</el-radio>
        <el-radio v-model="radio" label="2">双打</el-radio>
        <el-radio disabled v-model="radio" label="选中且禁用">备用</el-radio>
      </div>
    </div>

    <div class="box-one" style="margin-bottom: 20px">
      <div style="width: 71px">队友:</div>
      <div style="display: flex; flex-direction: row; align-items: center">
        <div
          class="box-one"
          style="
            margin-bottom: 20px;
            display: flex;
            margin-bottom: 20px;
            flex-direction: column;
          "
        >
          <el-autocomplete
            class="inline-input"
            v-model="state1"
            :fetch-suggestions="querySearch"
            placeholder="请输入内容"
            @select="handleSelect"
          ></el-autocomplete>
          <el-autocomplete
          v-if="radio == '2'"
            class="inline-input"
            v-model="state2"
            :fetch-suggestions="querySearch"
            placeholder="请输入内容"
            @select="handleSelect"
          ></el-autocomplete>
        </div>
        VS
        <div

          class="box-one"
          style="
            margin-bottom: 20px;
            display: flex;
            margin-bottom: 20px;
            flex-direction: column;
          "
        >
          <el-autocomplete
            class="inline-input"
            v-model="state3"
            :fetch-suggestions="querySearch"
            placeholder="请输入内容"
            @select="handleSelect"
          ></el-autocomplete>
          <el-autocomplete
          v-if="radio == '2'"
            class="inline-input"
            v-model="state4"
            :fetch-suggestions="querySearch"
            placeholder="请输入内容"
            @select="handleSelect"
          ></el-autocomplete>
        </div>
      </div>
    </div>

    <div class="box-one" style="margin-bottom: 20px">
      <div style="width: 71px">比分：</div>
      <el-input
        v-model="recordsdata.scoreinput"
        placeholder=""
        style="width: 25%"
      ></el-input>
      :
      <el-input
        v-model="recordsdata.scoreinput2"
        placeholder=""
        style="width: 25%"
      ></el-input>
    </div>

    <div class="box-button">
      <el-button type="primary" round @click="themebutton">进入</el-button>
    </div>
  </div>
</template>
<script>
import { MessageBox } from "mint-ui";
export default {
  name: "bindDetail",
  data() {
    return {
      radio: "2",
      state1: "",
      state2: "",
      state3: "",
      state4: "",
      recordsdata: {
        projId: "",
        devSysName: "",
        typeid: "",
        addressid: "",
        systemid: "",
        valuetime: "",
        typeid1: "",
        scoreinput: "",
        scoreinput2: "",
      },
      restaurants: [
        { value: "问号", address: "长宁区新渔路144号" },
        {
          value: "俊野",
          address: "上海市长宁区淞虹路661号",
        },
        {
          value: "呱呱",
          address: "上海市普陀区真北路988号创邑金沙谷6号楼113",
        },
        {
          value: "怀南",
          address: "上海市普陀区真北路988号创邑金沙谷6号楼113",
        },
      ],
      typedata: [
        {
          value: "选项1",
          label: "女双",
        },
        {
          value: "选项2",
          label: "男双",
        },
        {
          value: "选项3",
          label: "混双",
        },
        {
          value: "选项4",
          label: "男单",
        },
      ],
      systemdata: [
        {
          value: "选项1",
          label: "21",
        },
        {
          value: "选项2",
          label: "11",
        },
      ],
      addressdata: [
        {
          value: "选项1",
          label: "天通苑体育馆",
        },
        {
          value: "选项2",
          label: "北国",
        },
      ],
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      value: "",
      isShow: false,
      request: {
        phone: "",
        openId: "",
      },
      user: {},
    };
  },
  mounted() {
    this.request.openId = this.$route.query.openId;
    if (this.request.openId) {
      this.getUserInfo();
    }
  },
  methods: {
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleSelect(item) {
      console.log(item);
    },
    querySearch(queryString, cb) {
      console.log(queryString);
      console.log(cb);
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },

    themebutton() {
      console.log(this.state1);
    },
    //调用接口查询要绑定的用户信息
    getUserInfo() {
      //如果查询到则弹出是否绑定确认框,否则提示无此账号
      var _t = this;
      this.common.doActionGet(
        this.common.bindIsOk,
        { openId: this.request.openId },
        function (res) {
          console.log(res);
          if (res.code == 200) {
            //绑定成功,跳转到详情页bindDetail,否则提示失败原因
            _t.user = res.data;
            _t.request.phone = res.data.userphone;
          } else if (res.code == 201) {
            //未绑定微信
            var query = {
              openId: _t.request.openId,
            };
            _t.$router.push({
              path: "/bindPhone",
              query: query,
            });
          } else {
            MessageBox.alert(res.msg, "ERROR");
          }
        },
        "weixin"
      );
      this.isShow = true;
    },
    unbindWeChat() {
      var _t = this;
      MessageBox.confirm("解绑后将不再接受单位设备的报警信息！")
        .then((action) => {
          _t.common.doActionGet(
            _t.common.removeBindLny,
            _t.request,
            function (res) {
              if (res.code == 200) {
                //绑定成功,跳转到详情页bindDetail,否则提示失败原因
                var query = {
                  openId: _t.request.openId,
                };
                _t.$router.push({
                  path: "/bindPhone",
                  query: query,
                });
              } else {
                MessageBox.alert(res.msg, "ERROR");
              }
            },
            "weixin"
          );
        })
        .catch((_) => {});
    },
  },
};
</script>
<style scoped>
@import "../../../static/wechat/wechat.css";
.hello {
  height: 100%;
  padding: 0px 20px;
  margin-top: -40px;
}
.title1 {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  margin-top: 20px;
}
.title2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 75px;
  text-align: left;
}
.tip {
  font-size: 14px;
  color: #999999;
  text-align: left;
  margin-top: 14px;
}
.btn-code {
  width: 80px;
  height: 26px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #007aff;
  color: #007aff;
  font-size: 12px;
}
.btn-gray {
  width: 100%;
  height: 40px;
  margin-top: 100px;
}
.wechat-user-logo {
  margin-top: 80px;
}
.box-one {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.text-titel {
  width: 100%;
  padding: 20px 0px;
  font-size: 20px;
}
.box-button {
  margin-top: 30%;
}
</style>



// WEBPACK FOOTER //
// src/components/featheradd/featherhome.vue